import { useSelector } from 'react-redux';
import { TRootState } from 'store/index';

const useAuthSelector = () => {
    return useSelector((state: TRootState) => state.auth);
};

export default useAuthSelector;
